import { Box } from '@components/ui/atoms/Box';
import { Button } from '@components/ui/atoms/Button';
import { Flex } from '@components/ui/atoms/Flex';
import { Text } from '@components/ui/atoms/Text';
import { useServiceWorker } from '@shared/serviceWorker';
import { useEffect, useState } from 'react';

export const UpdateNotification = () => {
  const { isUpdateAvailable, updateServiceWorker } = useServiceWorker();
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (isUpdateAvailable) {
      setShow(true);
    }
  }, [isUpdateAvailable]);

  if (!show) {
    return null;
  }

  const handleUpdate = () => {
    updateServiceWorker();
    setShow(false);
  };

  const handleDismiss = () => {
    setShow(false);
  };

  return (
    <Box
      position="fixed"
      top="4"
      right="4"
      zIndex="9999"
      maxWidth="400px"
      bg="purple.400"
      color="white"
      borderRadius="md"
      boxShadow="lg"
      p="4"
    >
      <Text fontWeight="semibold" mb="2">
        Update Available
      </Text>
      <Text fontSize="sm" mb="3">
        A new version of the application is available.
      </Text>
      <Flex gap="2">
        <Button size="sm" visual="primary" colorScheme="whiteAlpha" onClick={handleUpdate}>
          Update Now
        </Button>
        <Button
          size="sm"
          visual="secondary"
          variant="ghost"
          colorScheme="whiteAlpha"
          onClick={handleDismiss}
        >
          Later
        </Button>
      </Flex>
    </Box>
  );
};
